
<app-navigation-list
    (onAdd)="emit_btnAddClick()"
    (onClick)="emit_onClick($event)"
    (onRestore)="emit_onRestore($event)"
    [(tabMode)]="tabMode$$"
    [btnAddData]="btnAddData$$()"
    [btnDeleteData]="btnDeleteData$$()"
    [claimPageList]="claimPageList$$()"
    [inactiveMode]="_inactiveMode.dimmed"
    [itemLines]="itemLines"
    [itemSize]="ItemSize"
    [noClick]="noClick$$()"
    [template]="template"
/>

<ng-template #template let-listItem>
    <app-badge>
        @if (listItem?.isOwner) {
            <app-icon name="domain-owner" [matTooltip]="'owner'" [matTooltipPosition]="'left'" />
        }
        @if (listItem?.isAdmin && !listItem?.isOwner) {
            <app-icon name="administrator" [matTooltip]="'administrator'" [matTooltipPosition]="'left'" />
        }
    </app-badge>
    <app-image-box-tab-list matListItemAvatar
        [border]="true"
        [noClick]="true"
        [guid]="listItem?.[logoGuid]"
    />
    <div>
        <h3 matListItemTitle>{{listItem?.[domainNr]}} - {{listItem?.[domainName]}}@if (!listItem?.[active]) {{{_inactiveSuffixText}}}</h3>
        @if (listItem?.[twoFactorRequired]) {
            <p matListItemLine>tweestapsverificatie vereist</p>
        } @else if (!listItem?.isOwner) {
            <p matListItemLine><span>owner: </span>{{listItem?.[domainOwnerEmail]}}</p>
        }
    </div>
</ng-template>
